import { useLocation, useNavigate } from 'react-router-dom'

import { Tabs as GammaTabs } from '@factorialco/deprecated-design-system'

import type { Tab } from 'modules/core/components/Card/types'

interface Props {
  tabs: Tab[]
}

export const PolicyDetailTabs = ({ tabs }: Props) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  return (
    <GammaTabs
      currentId={pathname}
      onTabClicked={(tabId) => {
        navigate(tabId)
      }}
    >
      {tabs.map((tab) => (
        <GammaTabs.Tab key={tab.href} id={tab.href} label={tab.name} />
      ))}
    </GammaTabs>
  )
}
